export default __filename;
angular
  .module(__filename, [])

  .factory(
    'Promise',
    ngInject(function($rootScope) {
      const Promise = require('bluebird');
      // http://stackoverflow.com/questions/23984471/how-do-i-use-bluebird-with-angular
      Promise.setScheduler((cb) => $rootScope.$evalAsync(cb));
      return Promise;
    }),
  );
